/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react';
import * as Yup from 'yup';
import clsx from 'clsx';
import {useDispatch} from 'react-redux';
import {Form, Input, Select, DatePicker, Radio} from 'antd';
import {requestPOST} from 'src/utils/baseAPI';
import {Link} from 'react-router-dom';
import {useFormik} from 'formik';
import {getUserByToken, login, getBranchByToken} from '../core/_requests';
import {toAbsoluteUrl} from '../../../../_metronic/helpers';
import {useAuth} from '../core/Auth';
import * as actionsGlobal from 'src/setup/redux/global/Actions';
import {useSelector} from 'react-redux';
import * as authHelper from 'src/app/modules/auth/core/AuthHelpers';
import {useIntl} from 'react-intl';


const FormItem = Form.Item;
const {Option} = Select;
export function Branch() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {saveAuth, currentUser, setCurrentUser, logout} = useAuth();
  const {token} = authHelper.getAuth();
  const currentBranch = useSelector((state) => state.global.currentBranch);
  const [form] = Form.useForm();
  const [dataBranch, setDataBranch] = useState([]);
  // console.log(currentUser);
  const [hideBtn, setHideBtn] = useState(false);
  const intl = useIntl();

  const valueChooseBranch = Form.useWatch('branchIds', form);

  useEffect(() => {
    if (valueChooseBranch) {
      setHideBtn(false);
    } else {
      setHideBtn(true);
    }
  });

  useEffect(() => {
    const fetchData = async () => {
      const {data: branches} = await getBranchByToken(token);

      if (branches && branches.length > 0) {
        setDataBranch(branches);
      }

      if (currentBranch) {
        form.setFieldsValue({
          branchIds: currentBranch,
        });
      }
    };

    fetchData();
    return () => {};
  }, []);

  const onFinish = () => {
    const values = form.validateFields();
    try {
      const formData = form.getFieldsValue(true);

      if (formData?.branchIds) {
        dispatch(actionsGlobal.setChooseBranch(true));
        dispatch(actionsGlobal.setCurrentBranch(formData.branchIds));
      }
    } catch (e) {}
  };
  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-center position-x-center bgi-no-repeat bgi-size-cover bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/auth/bg4.jpg')})`,
      }}


    >
          <div className='d-flex justify-content-start mb-10 mt-2 ms-2'>
      <button
        type='button'
        className='btn btn-light'
        onClick={() => {
          form.setFieldsValue({branchIds: null});
          dispatch(actionsGlobal.setChooseBranch(false));
          dispatch(actionsGlobal.setCurrentBranch(null));
          logout();
        }}
      >
        <i className='fas fa-arrow-left'></i>
        Đăng nhập
      </button>
    </div>

      {/* begin::Content */}
      <div className='d-flex flex-column flex-column-fluid flex-lg-row'>
        {/* begin::Logo */}
        {/*  <a href='#' className='mb-12'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/default.svg')} className='h-45px' />
        </a> */}
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10'>
          <div className='d-flex flex-center flex-lg-start flex-column'>
            <h1 className='text-white display-2 m-0'>Smart Parking</h1>
            <h2 className='text-white fw-normal m-0'>{intl.formatMessage({id: 'LOGINPAGE.FLEXING'})}</h2>
          </div>
        </div>
        <div className='d-flex flex-center w-lg-50'>
          <div className='w-md-550px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto'>
            <Form form={form} className='form w-100'>
              <div className='text-center mb-10'>
                <h1 className='text-dark mb-3'>{intl.formatMessage({id: 'LOGINPAGE.SELECTBRANCH'})}</h1>
              </div>

              {/* begin::Form group */}
              {/* <div className='fv-row mb-10'>
                <div className='d-flex justify-content-between mt-n5'>
                  <div className='d-flex flex-stack mb-2'> */}

              <FormItem
                label={intl.formatMessage({id: 'BRANCH.NAME'})}
                name='branchIds'
                rules={[{required: true, message: intl.formatMessage({id: 'FIELD.REQUIRE'})}]}
              >
                {dataBranch && (
                  <Select
                    allowClear
                    showSearch
                    placeholder={intl.formatMessage({id: 'BRANCH.NAME'})}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    // defaultValue={ currentBranch &&  currentBranch}
                  >
                    {dataBranch.map((item) => {
                      return (
                        <Option key={item?.id} value={item?.id}>
                          {item?.name}
                        </Option>
                      );
                    })}
                  </Select>
                )}
              </FormItem>
              {/* </div>
                </div>
              </div> */}
              {/* end::Form group */}

              {/* begin::Action */}
              <div className='text-center'>
                <button onClick={onFinish} className='btn btn-lg btn-primary w-100 mb-5' >
                  {!loading && <span className='indicator-label'>{intl.formatMessage({id: 'LOGINPAGE.SUCCESSBTN'})}</span>}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                        {intl.formatMessage({id: 'LOGINPAGE.PROCESSING'})}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* <div class='text-gray-500 text-center fw-semibold fs-6'>
        <Link className='link-primary' to='/auth/registration'>
          Đăng ký
        </Link>        
      </div>  */}
            </Form>
          </div>
        </div>
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      {/* <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <a href='#' className='text-muted text-hover-primary px-2'>
            About
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact Us
          </a>
        </div>
      </div> */}
      {/* end::Footer */}
    </div>
  );
}
